import { Component, OnInit } from '@angular/core';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';

import { KeycloakService } from 'keycloak-angular';



import { KeycloakStateService } from 'src/app/core/service/utility.service';

import { ErrorDialogComponent } from 'src/app/shared/dialogs/error-dialog/error-dialog.component';

import { SuccessDialogComponent } from 'src/app/shared/dialogs/success-dialog/success-dialog.component';

import { DataAssetSourceService } from '../services/data-asset-source.service';

import { AssetManagement } from '@aptsi-types';

import { WorkflowNavigationService } from '../../shared/workflow-navigation.service';




@Component({

  selector: 'app-data-asset-capture-file-create-or-update',

  templateUrl: './data-asset-capture-file-create-or-update.component.html',

  styleUrls: ['./data-asset-capture-file-create-or-update.component.scss']

})

export class DataAssetCaptureFileCreateOrUpdateComponent implements OnInit {

  form!: FormGroup;



  currentStep = 1;

  loading = false;

  importingAssets = false;



  organizationId = '';

  importedBy = '';

  importedByKeycloakId = '';



  selectedFile: File | null = null;

  fileError = '';

  importChoice: 'now' | 'later' | null = null;

  importCompleted = false;

  importedAssets: AssetManagement[] = [];

  importMessage = '';

  importError = false;

  completionMessage = '';



  isCreate = true;

  assetSourceId = '';



  loadingSource = false;

  hasLoadedSource = false;

  sourceLoadError = '';



  readonly steps = [

    { number: 1, title: 'Asset source', description: 'Enter source details' },

    { number: 2, title: 'Import assets', description: 'Upload a file or skip for now' },

    { number: 3, title: 'Review', description: 'Confirm and finish' }

  ];



  // The backend currently supports file-based asset sources only.

  readonly assetSourceTypeOptions = [

    { value: 'file', label: 'File' }

  ];



  // The file format is represented by assetSource in the completion request.

  readonly assetSourceOptions = [

    { value: 'csv', label: 'CSV file' },

    { value: 'excel', label: 'Excel spreadsheet' }

  ];



  constructor(

    private readonly fb: FormBuilder,

    private readonly dataAssetSourceService: DataAssetSourceService,

    private readonly keycloakStateService: KeycloakStateService,

    private readonly keycloakService: KeycloakService,

    private readonly route: ActivatedRoute,

    private readonly router: Router,

    private readonly dialog: MatDialog,

    private readonly workflowNavigation: WorkflowNavigationService

  ) { }



  ngOnInit(): void {

    this.isCreate = this.route.snapshot.data['create'] !== false;



    this.organizationId =

      this.keycloakStateService.getOrganizationId() || '';



    this.importedByKeycloakId =

      this.keycloakStateService.getUserId() || '';



    this.importedBy = this.getImportedByFromKeycloak();



    this.form = this.fb.group({

      assetSourceName: ['', [Validators.required, Validators.maxLength(120)]],

      assetSourceType: ['', Validators.required],

      assetSource: ['', [Validators.required, Validators.maxLength(200)]]

    });



    if (!this.isCreate) {

      this.assetSourceId =

        this.route.snapshot.paramMap.get('assetsourceId') ?? '';



      this.loadDataAssetSourceForUpdate();

    }

  }





  private loadDataAssetSourceForUpdate(): void {

    if (!this.assetSourceId) {

      this.sourceLoadError = 'Asset source ID is missing from the route.';

      return;

    }



    this.loadingSource = true;

    this.sourceLoadError = '';



    this.dataAssetSourceService

      .FetchDataAssetSourceDetails(this.assetSourceId)

      .subscribe({

        next: (source: AssetManagement) => {

          this.form.patchValue({

            assetSourceName: source.assetSourceName ?? source.assetsourceName ?? '',

            assetSourceType: source.assetSourceType ?? source.assetsourceType ?? 'file',

            assetSource: source.assetSource ?? source.assetsource ?? ''

          });



          this.hasLoadedSource = true;

          this.loadingSource = false;

        },

        error: error => {

          this.loadingSource = false;

          this.hasLoadedSource = false;



          this.sourceLoadError =

            this.extractMessage(error) ||

            'Unable to load the data asset source.';



          this.dialog.open(ErrorDialogComponent, {

            width: '360px',

            data: {

              errorMessage: this.sourceLoadError

            }

          });

        }

      });

  }



  get acceptedFileTypes(): string {

    return this.form?.get('assetSource')?.value === 'excel'

      ? '.xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel'

      : '.csv,text/csv';

  }



  get selectedSourceTypeLabel(): string {

    const value = this.form?.get('assetSourceType')?.value;

    return this.assetSourceTypeOptions.find(option => option.value === value)?.label || '—';

  }



  get selectedAssetSourceLabel(): string {

    const value = this.form?.get('assetSource')?.value;

    return this.assetSourceOptions.find(option => option.value === value)?.label || '—';

  }



  get canContinueToSummary(): boolean {

    return this.importChoice === 'later' ||

      (this.importChoice === 'now' && this.importCompleted);

  }



  get isImportNow(): boolean {

    return this.importChoice === 'now';

  }



  onAssetSourceChange(): void {

    this.resetImportState();

  }



  continueFromStepOne(): void {

    this.form.markAllAsTouched();

    if (this.form.invalid) {

      return;

    }



    this.resetImportState();

    this.currentStep = 2;

  }



  chooseImport(choice: 'now' | 'later'): void {

    if (this.importingAssets || this.importCompleted) {

      return;

    }



    this.importChoice = choice;

    this.importMessage = '';

    this.importError = false;



    if (choice === 'later') {

      this.selectedFile = null;

      this.fileError = '';

    }

  }



  onFileSelected(event: Event): void {

    const input = event.target as HTMLInputElement;

    const file = input.files?.[0] || null;

    this.assignSelectedFile(file);



    // Allows the same file to be selected again after it has been cleared.

    input.value = '';

  }



  onDragOver(event: DragEvent): void {

    event.preventDefault();

    event.stopPropagation();

  }



  onFileDrop(event: DragEvent): void {

    event.preventDefault();

    event.stopPropagation();

    const file = event.dataTransfer?.files?.[0] || null;

    this.assignSelectedFile(file);

  }



  removeSelectedFile(): void {

    this.selectedFile = null;

    this.fileError = '';

    this.importMessage = '';

    this.importError = false;

  }



  importAssets(): void {

    if (this.importChoice !== 'now' || this.importingAssets || this.importCompleted) {

      return;

    }



    if (!this.selectedFile) {

      this.fileError = 'Choose a file before importing data assets.';

      return;

    }



    if (this.form.invalid) {

      this.form.markAllAsTouched();

      this.currentStep = 1;

      return;

    }



    const value = this.form.getRawValue();

    this.importingAssets = true;

    this.importMessage = 'Uploading the file and importing data assets…';

    this.importError = false;



    this.dataAssetSourceService.importDataAssetsFromFileDuringSetup(

      this.selectedFile,

      this.organizationId,

      String(value.assetSourceName).trim(),

      String(value.assetSourceType),

      String(value.assetSource).trim(),

      this.importedBy,

      this.importedByKeycloakId

    ).subscribe({

      next: response => {

        const responseMessage = this.extractMessage(response) || 'File import request completed.';



        this.dataAssetSourceService.ReadDataAssetsFromStagingTable(

          this.importedByKeycloakId, String(value.assetSourceName).trim()

        ).subscribe({

          next: assets => {

            this.importedAssets = Array.isArray(assets) ? assets : [];

            this.importCompleted = true;

            this.importingAssets = false;

            this.importError = false;

            this.importMessage = `${responseMessage} ${this.importedAssets.length} data asset(s) loaded from staging.`;

          },

          error: error => {

            this.importingAssets = false;

            this.importCompleted = false;

            this.importError = true;

            this.importMessage = this.extractMessage(error) ||

              'The file was submitted, but the staging table could not be read. Try again.';

          }

        });

      },

      error: error => {

        this.importingAssets = false;

        this.importCompleted = false;

        this.importError = true;

        this.importMessage = this.extractMessage(error) ||

          'The file could not be imported. Check the file format and try again.';

      }

    });

  }



  continueToSummary(): void {

    if (!this.importChoice) {

      this.importMessage = 'Choose whether to import assets now or later.';

      this.importError = true;

      return;

    }



    if (!this.canContinueToSummary) {

      this.importMessage = 'Upload and import the selected file before continuing.';

      this.importError = true;

      return;

    }



    this.currentStep = 3;

  }



  finishSetup(): void {

    if (this.loading || !this.canContinueToSummary || this.form.invalid) {

      this.form.markAllAsTouched();

      return;

    }



    const value = this.form.getRawValue();

    const isAssetImport = this.importCompleted ? 'true' : 'false';

    this.loading = true;



    this.dataAssetSourceService.CompleteDataAssetCaptureFromFIle(

      String(value.assetSourceName).trim(),

      'data',

      String(value.assetSourceType),

      String(value.assetSource).trim(),

      this.organizationId,

      isAssetImport,

      this.importedByKeycloakId

    ).subscribe({

      next: response => {

        this.loading = false;

        this.completionMessage = this.extractMessage(response) ||

          'Data asset source setup completed successfully.';



        const dialogRef = this.dialog.open(SuccessDialogComponent, {

          width: '360px',

          data: {

            isCreate: true,

            isCreateUpdate: true,

            title: 'Data Asset Source',

            message: this.completionMessage

          }

        });



        dialogRef.afterClosed().subscribe(() => {

            void this.workflowNavigation.navigateToWorkflow(
    'dataAssetCapture'
  );

        });

      },

      error: error => {

        this.loading = false;

        this.dialog.open(ErrorDialogComponent, {

          width: '360px',

          data: {

            errorMessage: this.extractMessage(error) ||

              'Unable to complete the data asset source setup.'

          }

        });

      }

    });

  }



  submitUpdate(): void {

    const nameControl = this.form.get('assetSourceName');

    nameControl?.markAsTouched();



    const assetSourceName = String(nameControl?.value ?? '').trim();



    if (

      this.loading ||

      !this.hasLoadedSource ||

      !this.assetSourceId ||

      !nameControl ||

      nameControl.invalid ||

      !assetSourceName

    ) {

      return;

    }



    this.loading = true;



    this.dataAssetSourceService

      .UpdateDataAssetSourceDetails(

        this.assetSourceId,

        assetSourceName

      )

      .subscribe({

        next: response => {

          this.loading = false;



          const message =

            this.extractMessage(response) ||

            'Data asset source updated successfully.';



          const dialogRef = this.dialog.open(SuccessDialogComponent, {

            width: '360px',

            data: {

              isCreate: false,

              isCreateUpdate: true,

              title: 'Data Asset Source',

              message

            }

          });



          dialogRef.afterClosed().subscribe(() => {

             void this.workflowNavigation.navigateToWorkflow(
    'dataAssetCapture'
  );

          });

        },

        error: error => {

          this.loading = false;



          this.dialog.open(ErrorDialogComponent, {

            width: '360px',

            data: {

              errorMessage:

                this.extractMessage(error) ||

                'Unable to update the data asset source.'

            }

          });

        }

      });

  }



  previousStep(): void {

    if (this.currentStep > 1 && !this.loading && !this.importingAssets) {

      this.currentStep -= 1;

    }

  }



  cancel(): void {

  void this.workflowNavigation.navigateToWorkflow(
    'dataAssetCapture'
  );

  }

    navigateToDataAssetCapture(): void {
  void this.workflowNavigation.navigateToWorkflow(
    'dataAssetCapture'
  );
}



  formatFileSize(size: number): string {

    if (!Number.isFinite(size) || size < 0) {

      return '—';

    }

    if (size < 1024) {

      return `${size} B`;

    }

    if (size < 1024 * 1024) {

      return `${(size / 1024).toFixed(1)} KB`;

    }

    return `${(size / (1024 * 1024)).toFixed(1)} MB`;

  }



  trackByAsset(index: number, asset: AssetManagement): string | number {
    return asset.assetId || asset.uniqueIdentifier || asset.name || index;
  }



  formatClassification(value: string | string[] | null | undefined): string {
    if (Array.isArray(value)) {
      const items = value.map(item => String(item).trim()).filter(Boolean);
      return items.length ? items.join(', ') : '—';
    }

    const rawValue = String(value ?? '').trim();
    if (!rawValue || rawValue === '[]' || rawValue.toLowerCase() === 'null') {
      return '—';
    }

    try {
      const parsed: unknown = JSON.parse(rawValue);
      if (Array.isArray(parsed)) {
        const items = parsed.map(item => String(item).trim()).filter(Boolean);
        return items.length ? items.join(', ') : '—';
      }
    } catch {
      // The API may return a plain classification name rather than JSON.
    }

    return rawValue;
  }

  private assignSelectedFile(file: File | null): void {

    this.fileError = '';

    this.importMessage = '';

    this.importError = false;

    this.importCompleted = false;

    this.importedAssets = [];



    if (!file) {

      this.selectedFile = null;

      return;

    }



    const extension = file.name.split('.').pop()?.toLowerCase() || '';

    const assetSource = this.form.get('assetSource')?.value;

    const isExcel = assetSource === 'excel' && ['xlsx', 'xls'].includes(extension);

    const isCsv = assetSource === 'csv' && extension === 'csv';



    if (!isExcel && !isCsv) {

      this.selectedFile = null;

      this.fileError = assetSource === 'excel'

        ? 'Select an Excel file with an .xlsx or .xls extension.'

        : 'Select a CSV file with a .csv extension.';

      return;

    }



    this.selectedFile = file;

  }



  private resetImportState(): void {

    this.selectedFile = null;

    this.fileError = '';

    this.importChoice = null;

    this.importCompleted = false;

    this.importedAssets = [];

    this.importMessage = '';

    this.importError = false;

  }



  private getImportedByFromKeycloak(): string {

    try {

      const keycloak = this.keycloakService.getKeycloakInstance();

      const token = (keycloak?.tokenParsed || {}) as Record<string, unknown>;

      const username = token['preferred_username'] || token['name'] || token['email'];

      return username ? String(username) : '';

    } catch {

      return '';

    }

  }



  private extractMessage(responseOrError: unknown): string {

    if (typeof responseOrError === 'string') {

      return responseOrError;

    }



    const value = responseOrError as {

      error?: { message?: unknown } | string;

      message?: unknown;

      statusText?: unknown;

    } | null;



    const candidates: unknown[] = [

      typeof value?.error === 'object' && value.error ? value.error.message : value?.error,

      value?.message,

      value?.statusText

    ];



    const message = candidates.find(candidate => typeof candidate === 'string' && candidate.trim());

    return typeof message === 'string' ? message : '';

  }

}
